import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import TopStrip from '../components/TopStrip';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HelpButton from '../components/HelpButton';
import TestimonialsCarousel from '../components/TestimonialsCarousel';

import heroBanner from '../assets/images/hero-images/devops services.webp';
import heroMobile from '../assets/images/mobile-banners/devops-services-mobile.webp';
import topProviderBg from '../assets/images/webp-images/top-provider-bg.webp';
import pkg1 from '../assets/images/devops-pkg/f542fa988ada14063db1388398327c41-removebg-preview.png';
import pkg2 from '../assets/images/devops-pkg/a778c04637d874b005c5d80c4af0bcf5-removebg-preview.png';
import pkg3 from '../assets/images/devops-pkg/065a51b375f4ad4ecd49fa59a3a40c9a-removebg-preview.png';
import logo1 from '../assets/images/logo-slide/1.avif';
import logo2 from '../assets/images/logo-slide/2.avif';
import logo3 from '../assets/images/logo-slide/3.avif';
import logo4 from '../assets/images/logo-slide/4.avif';
import logo5 from '../assets/images/logo-slide/5.avif';
import logo6 from '../assets/images/logo-slide/6.avif';
import logo7 from '../assets/images/logo-slide/7.avif';
import logo8 from '../assets/images/logo-slide/8.avif';
import logo9 from '../assets/images/logo-slide/9.avif';
import phpTab from '../assets/images/tab-images/php1.webp';
import meanTab from '../assets/images/tab-images/2.webp';
import javaTab from '../assets/images/tab-images/3.webp';
import pythonTab from '../assets/images/tab-images/4.webp';

const logoImages = [logo1,logo2,logo3,logo4,logo5,logo6,logo7,logo8,logo9];

const excelCards = [
  { num:'01', title:'Quick response',        desc:'24/7 availability with fast and reliable response times.' },
  { num:'02', title:'Experienced experts',   desc:'Senior IT professionals with deep industry expertise.' },
  { num:'03', title:'No geek speak',         desc:'Clear and simple communication without technical overload.' },
  { num:'04', title:'Business savvy',        desc:'Strong understanding of IT aligned with business goals.' },
  { num:'05', title:'Guaranteed satisfaction', desc:'Reliable delivery with long-term client trust.' },
];

const lifecycleCards = [
  { title:'Silo-Free Culture',         desc:'We eliminate the wall between Dev and Ops using ChatOps, shared dashboards, and a single operational language.' },
  { title:'Infrastructure as Code',    desc:'Using Terraform and Ansible, we provision infrastructure through code — removing manual errors completely.' },
  { title:'Predictive Observability',  desc:'Prometheus and Grafana detect anomalies in real-time, often resolving issues before users notice.' },
  { title:'Automated Quality Gates',   desc:'Automated testing and security scans stop faulty code before it ever reaches production.' },
  { title:'Seamless Build Pipelines',  desc:'Jenkins, GitLab, or CircleCI — we build pipelines that merge, test, and validate automatically.' },
  { title:'Zero-Downtime Deployments', desc:'Blue/Green and Canary strategies ensure updates roll out safely without taking systems offline.' },
];

const tabData = [
  { id:'php',    label:'PHP / Laravel (The Speed Layer)',        img:phpTab,    content:'The 100ms Benchmark — We layer Nginx as a reverse proxy, Varnish for HTTP caching, and Redis for object caching. The result? PHP applications that handle 10x the traffic of a standard LAMP stack.' },
  { id:'mean',   label:'Mean / Mern (The Async Layer)',          img:meanTab,   content:'Node.js at Scale — Specialized PM2 process management and Nginx load balancing ensure your single-threaded event loop never gets blocked, even under massive concurrency.' },
  { id:'java',   label:'Java / Spring (The Enterprise Layer)',   img:javaTab,   content:'JVM Optimization — Custom Heap memory tuning and Garbage Collection strategies tailored to your application\'s footprint, ensuring stability for long-running enterprise processes.' },
  { id:'python', label:'Python (Django / Flask)',                img:pythonTab, content:'Overcoming the Bottleneck — We solve Python concurrency limits by implementing robust uWSGI or Gunicorn servers behind Nginx. We integrate Celery for async task offloading and PostgreSQL tuning.' },
];

function DevOpsServices() {
  const [activeTab, setActiveTab] = useState('php');
  const logoTrackRef = useRef(null);
  const animRef      = useRef(null);
  const posRef       = useRef(0);

  useEffect(() => {
    const track = logoTrackRef.current;
    if (!track) return;
    const run = () => {
      posRef.current -= 0.5;
      if (Math.abs(posRef.current) >= track.scrollWidth / 2) posRef.current = 0;
      track.style.left = posRef.current + 'px';
      animRef.current = requestAnimationFrame(run);
    };
    animRef.current = requestAnimationFrame(run);
    return () => cancelAnimationFrame(animRef.current);
  }, []);

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* HERO */}
      <section style={{ marginTop:'125px' }}>
        <div className="container-fluid p-0">
          <img src={heroBanner} width="1600" height="520" alt="DevOps Services" className="img-fluid w-100 d-none d-md-block" />
          <img src={heroMobile} width="768"  height="1000" alt="DevOps Services" className="img-fluid w-100 d-md-none d-block" />
        </div>
      </section>

      {/* 50+ YEARS */}
      <div className="container py-5 my-5 overflow-hidden">
        <div className="row align-items-center gy-4" data-aos="fade-up">
          <div className="col-lg-6 col-md-6 col-sm-12 d-flex flex-column align-items-center text-center">
            <div className="d-flex flex-sm-row flex-column align-items-center justify-content-center mb-3">
              <span className="txt-color fw-bold me-3" style={{ fontSize:'6.5rem', lineHeight:1 }}>50+</span>
              <div className="text-start text-uppercase small fw-500" style={{ opacity:0.6, lineHeight:1.4 }}>
                <strong>Years</strong><br />Of IT<br />Operation
              </div>
            </div>
            <div style={{ fontSize:'1.5rem', opacity:0.8 }}>
              Evolved into <span className="txt-color fw-bold">DevOps</span>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 position-relative ps-lg-5">
            <div className="vertical-line d-none d-md-block"></div>
            <h3 className="fs-4 fw-semibold mb-3" style={{ opacity:0.8 }}>
              DevOps offers a wide range of IT services to handle operational requirements along with CI/CD to keep you on a continuous path of advancement.
            </h3>
            <p className="mb-0">
              We have taken half a century of combined operational discipline and fused it with modern automation. The result? A complete, distraction-free process that empowers your business — whether you are scaling a startup or re-architecting an enterprise legacy system.
            </p>
          </div>
        </div>
      </div>

      {/* STATS */}
      <section className="bg-info-subtle py-3 my-5" data-aos="fade-left">
        <div className="container">
          <div className="row text-center">
            {[{n:'1,190',l:'MANAGED ASSETS'},{n:'91+',l:'CLOUD MIGRATIONS'},{n:'47',l:'ACADEMY-CERTIFIED EXPERTS'},{n:'100%',l:'SLA COMPLIANCE'}].map((s,i) => (
              <div className="col-md-3 mb-4 mb-md-0 position-relative" key={i}>
                <h2 className="fw-bold text-info display-5 mb-0">{s.n}</h2>
                <p className="text-uppercase mt-2 fw-semibold">{s.l}</p>
                {i < 3 && <div className="d-none d-md-block position-absolute top-0 end-0 h-100" style={{ width:'1px', backgroundColor:'gray' }}></div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TABS */}
      <section id="tab-section" className="my-5">
        <div className="container text-center">
          <h1 className="top-line">Curated <span className="text-info">High-Performance</span> Stacks.</h1>
          <p>We have benchmarked every combination. Whether you run PHP, Python, or Java, we deploy the exact caching layer your code needs to fly.</p>
        </div>
        <div className="container w-75 my-5 custom-tab-container">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            {tabData.map(t => (
              <li className="nav-item" key={t.id} role="presentation">
                <button className={`nav-link ${activeTab === t.id ? 'active':''}`} onClick={() => setActiveTab(t.id)} type="button">{t.label}</button>
              </li>
            ))}
          </ul>
          <div className="tab-content p-3">
            {tabData.map(t => (
              <div key={t.id} className={`tab-pane fade ${activeTab === t.id ? 'show active':''}`}>
                <div className="row align-items-center" style={{ minHeight:'300px' }}>
                  <div className="col-lg-6"><p style={{ fontSize:'1rem' }}>{t.content}</p></div>
                  <div className="col-lg-6 text-center"><img src={t.img} loading="lazy" alt={t.id} className="img-fluid" /></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EXCEL CARDS */}
      <section className="py-5 bg-light">
        <div className="container">
          <h3 className="text-center fw-bold fs-2 mb-5">How we claim to excel?</h3>
          <div className="row g-4 justify-content-center">
            {excelCards.map((c,i) => (
              <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6" key={i}>
                <div className="excel-card h-100">
                  <span className="fw-bold text-info fs-4 d-block mb-2">{c.num}</span>
                  <h6 className="fw-semibold mb-2">{c.title}</h6>
                  <p className="text-muted small mb-0">{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LIFECYCLE */}
      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold display-6 top-line">The Engineering Lifecycle</h2>
            <p className="text-muted fs-5">A distraction-free loop of continuous improvement</p>
          </div>
          <div className="row g-4">
            {lifecycleCards.map((c,i) => (
              <div className="col-md-6 col-lg-4" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="lifecycle-card h-100">
                  <h5>{c.title}</h5>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TOP PROVIDER BANNER */}
      <div className="container-fluid my-5">
        <div className="toppsbanner d-flex justify-content-center align-items-center text-center"
          style={{ backgroundImage:`url(${topProviderBg})` }}>
          <div className="hover-overlay"></div>
          <div className="toppsbanner-content text-white px-3" style={{ maxWidth:'600px', zIndex:2, position:'relative' }}>
            <h4 className="fw-semibold">Cloud Agnostic. Vendor Neutral.</h4>
            <p>Whether you run on AWS, Azure, Google Cloud, or Bare Metal — our certified engineers optimize your stack for your specific environment.</p>
          </div>
        </div>
      </div>

      {/* PACKAGES */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center top-line mb-5">DevOps <span className="txt-color">Packages</span></h2>

          {/* Foundation */}
          <div className="row align-items-center mb-5 bg-white rounded p-4 shadow-sm border">
            <div className="col-lg-6 order-lg-1 order-2">
              <h6 className="text-info fw-semibold">FOUNDATION · The Peace of Mind Layer</h6>
              <div className="mb-3"><span className="text-muted small d-block">Starts from</span>
                <h2 className="fw-bold mb-0">$399 <span className="fs-6 text-muted fw-normal">/ mo</span></h2></div>
              <p className="text-muted fst-italic">Target: Startups & Developers needing a solid baseline</p>
              <ul className="list-unstyled">
                <li>✅ Managed Operations: Full Server & Application Administration</li>
                <li>✅ 24/7 Human Monitoring: Eyes-on-glass response for uptime.</li>
                <li>✅ Config & Setup: Complete configuration assistance for your stack.</li>
                <li>✅ Git Integration: Versioning setup and repository integration</li>
                <li>✅ System Optimization: OS-level tweaks to ensure stability.</li>
                <li>✅ Multi-tier Support: Support for separate Web/DB environments.</li>
                <li>✅ Security Baseline: Firewall configuration, OS Patching & SSL.</li>
                <li>✅ Data Safety: Automated Daily Backups & Recovery.</li>
                <li>✅ Support: Unlimited Tickets (Email/Chat) with 15-min response.</li>
              </ul>
              <Link to="/contact" className="btn btn-outline-info mt-3">Secure My Server</Link>
            </div>
            <div className="col-lg-6 text-center order-lg-2 order-1 mb-4 mb-lg-0">
              <img src={pkg1} className="img-fluid floating-icon" width="450" alt="Foundation Package" />
            </div>
          </div>

          {/* Growth */}
          <div className="row align-items-center mb-5 bg-white rounded p-4 shadow-sm border border-info">
            <div className="col-lg-6 text-center mb-4 mb-lg-0">
              <img src={pkg2} className="img-fluid floating-icon" width="550" alt="Growth Package" />
            </div>
            <div className="col-lg-6">
              <span className="badge bg-info mb-2">BEST VALUE</span>
              <h6 className="text-info fw-semibold mt-2">GROWTH · Built for Speed & Automation</h6>
              <div className="mb-3"><span className="text-muted small d-block">Starts from</span>
                <h2 className="fw-bold mb-0 text-info">$799 <span className="fs-6 text-muted fw-normal">/ mo</span></h2></div>
              <p className="text-muted fst-italic">Target: High-Traffic Apps needing speed & automation</p>
              <ul className="list-unstyled">
                <li>✨ Everything in Foundation</li>
                <li>✅ Deployment Automation: Full CI/CD Pipeline Setup.</li>
                <li>✅ Optimized Stack: Speed tuning for PHP, Java, MERN, Python, etc.</li>
                <li>✅ Proactive Health: Auto-healing scripts & APM.</li>
                <li>✅ Resilience: Migration Assistance & Disaster Recovery (DR) Drills.</li>
                <li>✅ 24/7 Support: Round-the-Clock Technical Assistance.</li>
                <li>✅ Dedicated Tech Lead: A named engineer who knows your specific stack.</li>
              </ul>
              <Link to="/contact" className="btn btn-info mt-3 text-white">Accelerate Deployment</Link>
            </div>
          </div>

          {/* Enterprise */}
          <div className="row align-items-center mb-4 bg-white rounded p-4 shadow-sm border">
            <div className="col-lg-6 order-lg-1 order-2">
              <h6 className="text-info fw-semibold">ENTERPRISE · The Invincible Layer</h6>
              <div className="mb-3"><span className="text-muted small d-block">Starts from</span>
                <h2 className="fw-bold mb-0">$1399 <span className="fs-6 text-muted fw-normal">/ mo</span></h2></div>
              <p className="text-muted fst-italic">Target: Mission-Critical Businesses & Custom Architectures</p>
              <ul className="list-unstyled">
                <li>🚀 Everything in Scaling</li>
                <li>✅ Zero-Downtime Architecture: Multi-tier HA Setup & Load Balancing.</li>
                <li>✅ Infrastructure as Code: Terraform/Ansible & Custom Scripting.</li>
                <li>✅ Advance Security: Deep Security Assistance & Support (Audits/Pen-Testing).</li>
                <li>✅ Resilience: Geo-Redundancy, Disaster Recovery (DR) & Drills.</li>
                <li>✅ Integrations: Full Third-Party Integration and Support.</li>
                <li>✅ Staffing Solution: Access to Dedicated Resources & Staffing.</li>
                <li>✅ Priority Access & Support: Direct Phone Support & Slack Integration.</li>
              </ul>
              <Link to="/contact" className="btn btn-outline-info mt-3">Talk to Architect</Link>
            </div>
            <div className="col-lg-6 text-center order-lg-2 order-1 mb-4 mb-lg-0">
              <img src={pkg3} width="550" className="img-fluid floating-icon" alt="Enterprise Package" />
            </div>
          </div>
        </div>
      </section>

      <TestimonialsCarousel />

      {/* LOGO SLIDER */}
      <section className="logo-slider py-1 bg-white overflow-hidden mt-5">
        <h2 className="text-center text-uppercase top-line">The <span className="text-info fw-semibold">DDevOps</span> Toolkit</h2>
        <div className="container" style={{ margin:'1rem auto' }}>
          <div className="logo-wrapper">
            <div className="logo-track" ref={logoTrackRef} style={{ position:'relative' }}>
              {[...logoImages,...logoImages].map((img,i) => (
                <img key={i} src={img} loading="lazy" className="slide-logo-img" alt={`Logo ${(i%9)+1}`} height="60" />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default DevOpsServices;
